<template>
  <div class="clientes">
    <monitor-clientes />
  </div>
</template>

<script>
import MonitorClientes from '@/components/monitorCliente/Monitorv2.vue'

export default {
  name: 'Clientes',
  components: {
    MonitorClientes
  }
}
</script>
